<template>
  <div class="content-container">
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        dom-layout="scroll"
        :auto-select-first-row="false"
        :row-multi-select-with-click="true"
        :rows="rows"
        class="agGrid"
        @refresh="onRefresh"
        @selectionChanged="rowSelectionChanged"
      />
    </div>
    <div class="button-containers mb-0">
      <button
        class="btn primary small outline"
        :disabled="selectedRows.length == 0"
        @click="deleteServiceType"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        class="btn primary small"
        :disabled="selectedRows.length !== 1"
        @click="editServiceType"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="openDialog">
        {{ $t('button.add') }}
      </button>
    </div>
    <el-dialog
      :title="
        isEdit ? $t('dialog.serviceTypeUpdate') : $t('dialog.serviceTypeAdd')
      "
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required|max:20" name="Mã loại">
                  <div class="das-form-input">
                    <div class="label required">Mã loại:</div>
                    <div class="child-w-80">
                      <input
                        v-model="serviceTypeItem.code"
                        type="text"
                        :readonly="isEdit"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required|max:100" name="Mô tả">
                  <div class="das-form-input">
                    <div class="label required">Mô tả:</div>
                    <div class="child-w-80">
                      <textarea v-model="serviceTypeItem.desc" rows="3" />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
          </div></div
      ></validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small"
            @click="updateServiceType"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addServiceType">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import {
  getListServiceTypeApi,
  addServiceTypeApi,
  updateServiceTypeApi,
  deleteServiceTypeApi
} from '@/api/configuration/accounting/product/serviceType.js'
import { Message } from 'element-ui'
export default {
  data() {
    return {
      selectedRows: [],
      loading: false,
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Mã loại',
          field: 'code',
          tooltipField: 'code',
          width: 100
        },
        {
          headerName: 'Mô tả',
          field: 'desc',
          tooltipField: 'desc'
        }
      ],
      rowId: null,
      rows: [],
      form: [],
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {},
      serviceTypeItem: {
        id: 0,
        p_code: 'SERVICE_TP',
        code: '',
        desc: ''
      }
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetInfo()
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  mounted() {
    this.attachData()
  },
  methods: {
    rowSelectionChanged(row) {
      this.selectedRows = row
    },
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    resetInfo() {
      this.isEdit = false
      this.serviceTypeItem = {
        id: null,
        p_code: 'SERVICE_TP',
        code: '',
        desc: ''
      }
    },
    openDialog() {
      this.dialogFormVisible = true
    },
    // table controller
    onRowClick(index) {
      document.getElementById(`currency-${index}`).classList.add('row-focus')
      if (this.rowId != null) {
        document
          .getElementById(`currency-${this.rowId}`)
          .classList.remove('row-focus')
      }
      this.rowId = index
    },
    // CRUD
    async addServiceType() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await addServiceTypeApi(this.serviceTypeItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    editServiceType() {
      const row = this.selectedRows[0] || []
      this.isEdit = true
      this.dialogFormVisible = true
      Object.assign(this.serviceTypeItem, row)
    },
    async deleteServiceType() {
      const ids = this.selectedRows.map(item => item.id) || []
      this.$vxConfirm(this.$t('alert.deleteServiceTypeConfirm'), () => {
        deleteServiceTypeApi({
          ids: ids
        })
          .then(async res => {
            const message = res.message
            await this.attachData()
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${message}`)
            })
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
      })
    },
    async updateServiceType() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await updateServiceTypeApi(this.serviceTypeItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async attachData() {
      this.loading = true
      let data = await getListServiceTypeApi(this.searchParams)
      this.loading = false
      this.rows = data.data
      this.selectedRows = []
    }
  }
}
</script>
